import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import cx from 'classnames'
import {Tooltip, Overlay} from 'react-bootstrap'
import style from './DashboardPanel.less'

class DashboardPanel extends Component {
    static propTypes = {
        size: PropTypes.string,
        light: PropTypes.bool,
        status: PropTypes.string,
        header: PropTypes.object.isRequired,
        help: PropTypes.object,
        onClick: PropTypes.func
    }

    static defaultProps = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openHelp(event) {
        event.preventDefault()
        this.setState({helpOpened: true})
    }

    _closeHelp() {
        this.setState({helpOpened: false})
    }

    render() {
        const {children, size, light, status, header, help, onClick} = this.props
        const {helpOpened} = this.state
        const {helpButton, helpContainer} = this.refs
        const sizeClass = size && size.toLowerCase()
        const statusClass = status && status.toLowerCase()

        return (
            <div
                className={cx(style.default, style[sizeClass], style[statusClass], {[style.light]: light, [style.clickable]: onClick})}
                onClick={onClick}>
                <div
                    ref='helpContainer'
                    className={style.header}>
                    {help && (
                        <div className={style.headerSide}>
                            <a
                                ref='helpButton'
                                className={style.help}
                                href=''
                                onClick={(e) => this._openHelp(e)}
                                onMouseOver={(e) => this._openHelp(e)}
                                onMouseOut={() => this._closeHelp()}>
                                ?
                            </a>
                            <Overlay rootClose
                                target={() => findDOMNode(helpButton)}
                                placement='bottom'
                                show={helpOpened}
                                container={helpContainer}
                                onHide={() => this._closeHelp()}>
                                <Tooltip>
                                    {help}
                                </Tooltip>
                            </Overlay>
                        </div>
                    )}
                    <div className={style.headerMain}>
                        {header}
                    </div>
                </div>
                <div className={style.body}>
                    <div className={style.bodyContent}>
                        {children}
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardPanel


// WEBPACK FOOTER //
// ./lib/core/components/DashboardPanel.js